import httpClient from 'src/configs/http-client';
import { IResponse } from 'src/types';

import { IContactForm } from '.';

export const postContactUs = async (value: IContactForm) => {
  const response = await httpClient.post<IResponse<any>>(`${process.env.REACT_APP_API_URL}/users/contact-us`, value);
  return response?.data;
};
